import { P0, S, abs, core, max, moodK, scaleAt, sq } from '../../geometry';

export const waves = {
  name: 'Waves',
  colors: ['#1FA2D6', '#3E63DD'],
  draw(m, t) {
    let A = 1.5,
      ph = t * 1.5,
      ys = [28, 72, 82],
      pose = P0();
    if (m === 'happy') {
      A = 4;
      ph = t * 8;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the waves keep travelling.
    if (m === 'thinking') {
      A = 3;
      ph = t * 4;
    }
    if (m === 'talking') {
      A = 1 + 3 * max(0, S(t * 10));
      ph = t * 3;
    }
    if (m === 'surprised') {
      A = 0.3;
      ph = t * 20;
      ys = [20, 76, 88];
    }
    if (m === 'paused') {
      A = 0.4;
      ph = t * 0.6;
      ys = [36, 70, 76];
    }
    return {
      strokes: ys.map((y0, j) => ({
        c: j ? 'a' : 'b',
        pts: [...Array(9)].map((_, k) => [
          22 + k * 7,
          y0 + A * S(k * 0.9 + ph + j * 1.3),
        ]),
      })),
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(
      core(scaleAt(sq(50, 52, 20, 12.5, 3), 50, 52, moodK(m, t)))
    );
    return f;
  },
};
